import React, { useState } from "react";
import "./styles.css";
import { AiOutlineSearch } from "react-icons/ai";
import { Collapse } from "react-collapse";
import { NavLink } from "react-router-dom";
import SideNav from './../../../components/SideNav';
var _id = localStorage.getItem("id_agent");

export default function RI_Painel() {
    let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro">
                <NavLink id="RI-cadastro" to="/RI"><button id="exit-RI-Cadastro">Voltar</button></NavLink>
                <div style={{display:"flex", flexDirection:"row"}}>
                    <Collapse isOpened={search}>
                        <input id="RI-Cadastro-Search" placeholder="pesquisar..." />
                    </Collapse>
                    <AiOutlineSearch
                        size={"6vh"}
                        onClick={() =>
                            setSearch(!search)
                        }
                        id="Icon-Search-RI-Cadastro"
                    />
                </div>
            </div>
            <div id="main-RI-Painel">
                <div id="actions-RI-Painel">
                    <p id="RI-Painel">Ações</p>
                    <hr id="divider-RI-Painel" />
                    <div id="collapsed-RI_Painel">
                        <NavLink to={{pathname:"/RI_PacientesLista/"+ _id}}><button id="option-RI-Painel">Listar pacientes</button></NavLink>                      
                        <NavLink to={{pathname:"/RI_Consulta/"+ _id}}><button id="option-RI-Painel">Consultas</button></NavLink>
                    </div>
                </div>
            </div>
        </>
    );
}


//Code original
/* 
    <NavLink to={{pathname:"/RI_SolicitarConsulta/"+ _id}}><button id="option-RI-Painel">Agendar Consulta</button></NavLink>
*/